import React from "react";
import { inject } from "mobx-react";

import SubscriptionComponent from "./SubscriptionComponent";
import LoadingComponent from "~/components/LoadingComponent";
import AlertComponent from "~/components/AlertComponent";
import { valueCurrencyToInt }  from "../../helpers/monetary"
import { dateFormat } from '../../helpers/utils'
import { getVarFromUrl } from "../../helpers/utils";
import { IMPLANTATION_STATUS, FREQUENCY_CHARGE } from "../../configs/constants"
import { format } from 'date-fns';

@inject("SubscriptionStore", "OrganizationStore")
class SubscriptionContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      subscription: {},
    };
  }

  async componentDidMount() {
    await this.getSubscription();
  }

  getSubscription = async () => {
    this.setState({
      isLoading: true,
    });

    const { SubscriptionStore, OrganizationStore, history } = this.props;
    const organizationId = getVarFromUrl("organizationId");
    const organization = await OrganizationStore.getOrganization(organizationId);
    const hasOrganization = organizationId !== undefined && parseInt(organizationId) > 0;
    if(!hasOrganization){
      history.push("/");
      return;
    }

    let subscription = await SubscriptionStore.getSubscriptionByOrganization(organizationId);

    if (subscription === undefined || subscription === null || subscription === "") {
      subscription = {};
      subscription.organizationId = organizationId;
      subscription.valueStr = 0.00.toFixed(2);
      subscription.valueTransferStr = 0.00.toFixed(2);
      subscription.valueImplantationStr = 0.00.toFixed(2);
      subscription.cycle = FREQUENCY_CHARGE.none;
      subscription.statusImportation = IMPLANTATION_STATUS.waiting;
      subscription.startDate = format(new Date(), 'yyyy-MM-dd');
      subscription.nextDueDate = format(new Date(), 'yyyy-MM-dd');
      subscription.numberDevices = 1;
    } 
    else {
      subscription.valueStr = (subscription.value / 100.00).toFixed(2);
      subscription.valueTransferStr = (subscription.valueTransfer / 100.00).toFixed(2);
      subscription.valueImplantationStr = (subscription.valueImplantation / 100.00).toFixed(2);
    }

    subscription.organizationName = organization.name;
    this.setState({
      subscription,
      organization,
      isLoading: false,
    });
  };

  goOrganization = () => {
    const { history } = this.props;
    history.push(`organizations`);
  };

  maintainSubscription = async () => {
    this.setState({
      isLoading: true
    });

    const { subscription } = this.state;
    const { SubscriptionStore } = this.props;        
   
    const result = await SubscriptionStore.maintainSubscription(subscription);
    if (result && result?.subscriptionId > 0) {
      await this.getSubscription();
      AlertComponent.success("Mensalidade salva com successo");
    }
    else { 
      AlertComponent.error("Falha ao salvar mensalidade");
    }    

    this.setState({
      subscription,
      isLoading: false
    });
  };

  onChange = (e) => {
    const { subscription } = this.state;
    const updatedSubscription = {
      ...subscription,
      [e.target.name]: e.target.value
    }

    this.setState({
      subscription: updatedSubscription,
    });
  };

  onChangeValue = (e) => {
    const { subscription } = this.state;
    subscription.value = valueCurrencyToInt(e.target.value);
    this.setState({
      subscription
    });
  };

  onChangeValueTransfer = (e) => {
    const { subscription } = this.state;
    subscription.valueTransfer = valueCurrencyToInt(e.target.value);
    this.setState({
      subscription
    });
  };

  onChangeValueImplantation = (e) => {
    const { subscription } = this.state;
    subscription.valueImplantation = valueCurrencyToInt(e.target.value);
    this.setState({
      subscription
    });
  };

  onChangeDueDate = (e) => {
    const { subscription } = this.state;
    subscription.nextDueDate = dateFormat(e);
    this.setState({
      subscription
    });
  };

  onChangeStartDate = (e) => {
    const { subscription } = this.state;
    subscription.startDate = dateFormat(e);
    this.setState({
      subscription
    });
  };

  render() {
    const { isLoading, subscription, organization } = this.state;
    return (
      <>
        {(isLoading && (
          <>
            <LoadingComponent />
          </>
        )) || (
          <div className="content content-xs">
            <SubscriptionComponent
              organization={organization}
              subscription={subscription}
              onClick={this.maintainSubscription}
              onCancel={this.goOrganization}
              onChange={this.onChange}
              onChangeValue={this.onChangeValue}
              onChangeValueTransfer={this.onChangeValueTransfer}
              onChangeValueImplantation={this.onChangeValueImplantation}
              onChangeDueDate={this.onChangeDueDate}
              onChangeStartDate={this.onChangeStartDate}
            />
          </div>
        )}
      </>
    );
  }
}

export default SubscriptionContainer;
